/**
 * app-search — types + validator for the global search-state of `_app` layout.
 *
 * Centralizes overlays mounted at `_app` level into URL (currently,
 * multi-account switcher), so pasting the URL into another browser
 * reopens exact same screen/overlay.
 *
 * Pattern: `validateSearch` omits defaults (does not pollute URL in empty state)
 * and hosts reflect URL->signals + navigate with `{ replace: true }` on
 * open/close (idempotent, survives back/forward and pasted URLs). Child
 * route searches merge with these.
 */

interface AppLayoutSearch {
  // ── Account switch (multi-account #18) ─────────────────────────────────────
  /** Account switcher open (`?account=switch`).*/
  account?: "switch";
}

/**
 * Validates + normalizes the layout search. Omits defaults to keep the URL
 * clean. Tolerant: unknown values are discarded (rendering does not break).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};

  // ── Account switcher (multi-account) ──
  if (search.account === "switch") {
    out.account = "switch";
  }

  return out;
}
